
import "/home/vsts/work/1/s/src/layouts/headerTitleRender/index.module.less?modules";
export default {"wrap": `wrap-l2tWzD-H`,"logo": `logo-c4_EIUA2`,"projectName": `projectName-xd55hYKI`}
